// extracted by mini-css-extract-plugin
export default {"cards":"newscards_cards__GJ2Cm"};